import loadable from '@loadable/component';

export const CmsBlockquoteBlockLoadable = loadable(
  () => import('./CmsBlockquoteBlock'),
  { resolveComponent: (module) => module.CmsBlockquoteBlock },
);
